var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrigger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5614 24.0942L9.60056 16.1007H2.43308C1.82024 16.1007 1.42057 15.4346 1.76695 14.9017L9.97359 1.3927C10.4265 0.646646 11.5456 1.04632 11.4391 1.89896L10.3999 9.89243H17.5674C18.1802 9.89243 18.5799 10.5585 18.2335 11.0914L10.0269 24.6271C9.57391 25.3465 8.45483 24.9468 8.5614 24.0942Z",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrigger);
export default __webpack_public_path__ + "static/media/trigger.e4c68f960c9dd1e00894136e374af2f4.svg";
export { ForwardRef as ReactComponent };